import(/* webpackMode: "eager" */ "/var/www/droidcare/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-sans\",\"display\":\"swap\"}],\"variableName\":\"dmSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/var/www/droidcare/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/droidcare/src/styles/tailwind.css");
